import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import albumService from "../../../services/album.service";
export interface Album {
  id?: string;
  _id?: any;
  name: string;
  price: any;
  type: string;
  artist: string;
  commision: any;
  description: string;
  image: any;
}
// initial values
const initialState = {
  albums: [],
  loading: false,
  error: null,
  totalPrice: 0,
  totalProfit: 0,
  currentAlbum: null,
  randomAlbums: [],
  paginationInfo: {
    totalItems: 0,
    itemsPerPage: 9,
    currentPage: 1,
  },
};

// actions
export const fetchAlbums = createAsyncThunk(
  "albums/fetchAlbums",
  async ({ page, limit }: any, { rejectWithValue }) => {
    try {
      const response = await albumService.getAll(page, limit);
      return response.data?.data;
    } catch (error: any) {
      console.error("Error fetching albums:", error.message);
      return rejectWithValue(error.message);
    }
  }
);
export const fetchAlbumsCounts = createAsyncThunk(
  "albums/fetchAlbumsCount",
  async ({ page, limit }: any, { rejectWithValue }) => {
    try {
      const response = await albumService.getAll();
      return response.data?.length;
    } catch (error: any) {
      console.error("Error fetching albums:", error.message);
      return rejectWithValue(error.message);
    }
  }
);
export const fetchComboAlbums = createAsyncThunk(
  "albums/fetchComboAlbums",
  async ({ page, limit }: any, { rejectWithValue }) => {
    try {
      const response = await albumService.getAllCombo(page, limit);
      return response.data?.data;
    } catch (error: any) {
      return rejectWithValue(error?.message);
    }
  }
);
export const fetchComboAlbumsCount = createAsyncThunk(
  "albums/fetchComboAlbumsCount",
  async ({ page, limit }: any, { rejectWithValue }) => {
    try {
      const response = await albumService.getAllCombo();
      return response.data?.length;
    } catch (error: any) {
      return rejectWithValue(error?.message);
    }
  }
);
export const fetchNonComboAlbumsCount = createAsyncThunk(
  "albums/fetchNonComboAlbumsCount",
  async ({ page, limit }: any, { rejectWithValue }) => {
    try {
      const response = await albumService.getAllNonCombo();
      return response.data?.length;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);
export const fetchNonComboAlbums = createAsyncThunk(
  "albums/fetchNonComboAlbums",
  async ({ page, limit }: any, { rejectWithValue }) => {
    try {
      const response = await albumService.getAllNonCombo(page, limit);
      return response.data?.data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

// get by id

export const getAlbumById = createAsyncThunk(
  "albums/getAlbumById",
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await albumService.getById(id);
      return response.data?.data;
    } catch (error: any) {
      console.log(error?.message);
      return rejectWithValue(error?.message);
    }
  }
);
export const getSetById = async (userId: string, id: string) => {
  try {
    const response = await albumService.getSetId(userId, id);
    return response.data?.data;
  } catch (error: any) {
    console.error(error?.message);
  }
};
export const getTasksTobeEditedById = async (userId: string, id: string) => {
  try {
    const response = await albumService.getTasksToBeEdited(userId, id);
    return response.data?.data;
  } catch (error: any) {
    console.error(error?.message);
  }
};
export const handleTaskUpdates = async (taskId: string, data: any) => {
  try {
    const response = await albumService.updateset(taskId, data);
    return response.data?.message;
  } catch (err: any) {
    console.error(err?.message);
  }
};

// delete album
export const deleteAlbum = createAsyncThunk(
  "albums/deleteAlbum",
  async (id: string, { rejectWithValue }) => {
    try {
      await albumService.delete(id);
      const response = await albumService.getAll();
      return response.data?.data;
    } catch (error: any) {
      console.log(error?.message);
      return rejectWithValue(error.message);
    }
  }
);

// updating album

export const updateAlbum = createAsyncThunk(
  "albums/updateAlbum",
  async (
    { id, name, price, artist, commision, description, image }: any,
    { rejectWithValue }
  ) => {
    const formData = new FormData();
    formData.append("name", name);
    formData.append("price", price);
    formData.append("commision", commision);
    formData.append("description", description);
    formData.append("artist", artist);
    if (image) {
      formData.append("image", image);
    }

    try {
      await albumService.update(id, formData);
      const response = await albumService.getAll();
      return response.data?.data;
    } catch (error: any) {
      console.log(error?.message);
      return rejectWithValue(error?.message);
    }
  }
);

// create album

export const createAlbum = createAsyncThunk(
  "albums/createAlbum",
  async (
    { name, price, type, artist, commision, description, image }: Album,
    { rejectWithValue }
  ) => {
    const formData = new FormData();
    formData.append("name", name);
    formData.append("price", price);
    formData.append("commision", commision);
    formData.append("description", description);
    formData.append("artist", artist);
    if (image) {
      formData.append("image", image);
    }

    try {
      await albumService.create(formData);
      const response = await albumService.getAll();
      return response.data?.data;
    } catch (error: any) {
      console.log(error?.message);
      return rejectWithValue(error?.message);
    }
  }
);
//get rondom album
export const getRandomAlbums = createAsyncThunk(
  "albums/randomAlbum",
  async (
    {
      userId,
      numberOfTasks,
    }: {
      userId: string;
      numberOfTasks: number;
    },
    { rejectWithValue }
  ) => {
    try {
      const data = { albumNUmber: numberOfTasks };
      const response = await albumService.getRandomAlbumsByUserId(userId, data);
      if (response.status == 200) {
        return response.data;
      } else {
        return rejectWithValue(response.data.message);
      }
    } catch (error: any) {
      return rejectWithValue(error?.message);
    }
  }
);
// create slice
export const albumsSlice = createSlice({
  name: "albums",
  initialState,
  reducers: {
    setInitialAlbumState: (state) => {
      return {
        ...state,
        loading: false,
        error: null,
        totalPrice: 0,
        totalProfit: 0,
        currentAlbum: null,
        randomAlbums: [],
      };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAlbums.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAlbums.fulfilled, (state, action) => {
        state.loading = false;
        state.albums = action.payload;
        state.error = null;
        const totalPrice = action.payload.reduce(
          (total: number, album: any) => {
            return total + (album.price || 0);
          },
          0
        );
        const totalProfit = action.payload.reduce(
          (total: number, album: any) => {
            return total + (album.commision || 0);
          },
          0
        );
        state.totalPrice = totalPrice;
        state.totalProfit = totalProfit;
      })
      .addCase(fetchAlbums.rejected, (state: any, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // combo
      .addCase(fetchComboAlbums.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchComboAlbums.fulfilled, (state, action) => {
        state.loading = false;
        state.albums = action.payload;
        state.error = null;
        const totalPrice = action.payload.reduce(
          (total: number, album: any) => {
            return total + (album.price || 0);
          },
          0
        );
        const totalProfit = action.payload.reduce(
          (total: number, album: any) => {
            return total + (album.commision || 0);
          },
          0
        );
        state.totalPrice = totalPrice;
        state.totalProfit = totalProfit;
      })
      .addCase(fetchAlbumsCounts.pending, (state: any, action) => {
        state.loading = true;
      })
      .addCase(fetchAlbumsCounts.fulfilled, (state: any, action) => {
        state.loading = false;
        state.paginationInfo.totalItems = action.payload;
      })
      .addCase(fetchAlbumsCounts.rejected, (state: any, action) => {
        state.loading = false;
      })
      //
      .addCase(fetchComboAlbums.rejected, (state: any, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // non combo
      .addCase(fetchNonComboAlbums.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchNonComboAlbums.fulfilled, (state, action) => {
        state.loading = false;
        state.albums = action.payload;
        state.error = null;
        const totalPrice = action.payload.reduce(
          (total: number, album: any) => {
            return total + (album.price || 0);
          },
          0
        );
        const totalProfit = action.payload.reduce(
          (total: number, album: any) => {
            return total + (album.commision || 0);
          },
          0
        );
        state.totalPrice = totalPrice;
        state.totalProfit = totalProfit;
      })
      .addCase(fetchNonComboAlbums.rejected, (state: any, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchNonComboAlbumsCount.pending, (state: any, action) => {
        state.loading = true;
      })
      .addCase(fetchNonComboAlbumsCount.rejected, (state: any, action) => {
        state.loading = false;
      })
      .addCase(fetchComboAlbumsCount.pending, (state: any, action) => {
        state.loading = true;
      })
      .addCase(fetchComboAlbumsCount.rejected, (state: any, action) => {
        state.loading = false;
      })
      .addCase(fetchNonComboAlbumsCount.fulfilled, (state: any, action) => {
        state.loading = false;
        state.paginationInfo.totalItems = action.payload;
      })
      .addCase(fetchComboAlbumsCount.fulfilled, (state: any, action) => {
        state.loading = false;
        state.paginationInfo.totalItems = action.payload;
      })

      // delete
      .addCase(deleteAlbum.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteAlbum.fulfilled, (state, action) => {
        const index = state.albums.findIndex(
          ({ id }) => id === action.payload.id
        );
        state.albums.splice(index, 1);
      })
      .addCase(deleteAlbum.rejected, (state: any, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // update album
      .addCase(updateAlbum.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateAlbum.fulfilled, (state, action) => {
        state.loading = false;
        state.albums = action.payload;
        state.error = null;
      })
      .addCase(updateAlbum.rejected, (state: any, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // get by id
      .addCase(getAlbumById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAlbumById.fulfilled, (state, action) => {
        state.loading = false;
        state.albums = action.payload;
        state.currentAlbum = action.payload;
        state.error = null;
      })
      .addCase(getAlbumById.rejected, (state: any, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // create album
      .addCase(createAlbum.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createAlbum.fulfilled, (state, action) => {
        state.loading = false;
        state.albums = action.payload;
        state.error = null;
      })
      .addCase(createAlbum.rejected, (state: any, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      //get rondom reducers
      .addCase(getRandomAlbums.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getRandomAlbums.fulfilled, (state, action) => {
        state.loading = false;
        state.randomAlbums = action.payload;
        state.error = null;
      })
      .addCase(getRandomAlbums.rejected, (state: any, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

// selectors
export const selectLoading = (state: any) => state.albums.loading;
export const selectAllAlbums = (state: any) => state.albums.albums;
export const selectAlbumErrors = (state: any) => state.albums.error;
export const selectTotalPrice = (state: any) => state.albums.totalPrice;
export const selectTotalProfit = (state: any) => state.albums.totalProfit;
export const selectCurrentAlbum = (state: any) => state.albums.currentAlbum;
export const selectPaginationInfo = (state: any) => state.albums.paginationInfo;
export const selectRondomAlbums = (state: any) => state.albums.randomAlbums;
export const { setInitialAlbumState } = albumsSlice.actions;

export default albumsSlice.reducer;
